export default {
  setPrivateOfferModal({
    dispatch,
  }, {
    id,
    isShown,
  }) {
    dispatch('showPrivateOfferModal', isShown);

    if (id) {
      dispatch('fetchOffer', id);
      dispatch('setOfferId', id);
    }
  },
  showPrivateOfferModal({
    dispatch,
  }, isShown) {
    dispatch('resetState');
    dispatch('setShown', isShown);
  },
  setFormData({
    dispatch,
  }, offer) {
    dispatch('setOfferName', offer.name);
    dispatch('setServices', offer.services);
    dispatch('setValidFrom', offer.validFrom);
    dispatch('setValidTo', offer.validTo);
    dispatch('setCreatedAt', offer.createdAt);
    dispatch('setCountdownEnabled', offer.isCountdownEnabled);
    dispatch('setSlug', offer.slug);
    dispatch('setManager', offer.manager);
    dispatch('setBottomBanner', offer.bottomBanner);
    dispatch('setTopBanner', offer.topBanner);
    dispatch('setTopBannerId', offer.topBanner?.id);
    dispatch('setBottomBannerId', offer.bottomBanner?.id);
  },
  fetchOffer({
    dispatch,
    rootGetters,
  }, id) {
    dispatch('setLoading', true);

    rootGetters['privateOffers/getRepository'].show(id)
      .then((response) => {
        dispatch('setFormData', response);
      })
      .catch((errors) => {
        dispatch('setErrors', errors);
      })
      .finally(() => {
        dispatch('setLoading', false);
      });
  },
  setLoading({ commit }, value) {
    commit('SET_LOADING', value);
  },
  setOfferName({ commit }, name) {
    commit('SET_NAME', name);
  },
  setValidFrom({ commit }, validFrom) {
    commit('SET_VALID_FROM', validFrom);
  },
  setValidTo({ commit }, validTo) {
    commit('SET_VALID_TO', validTo);
  },
  save({
    state, rootGetters, dispatch,
  }, { errorNotify }) {
    if (state.offerId) {
      rootGetters['privateOffers/getRepository'].update(state.offerId, state.formData)
        .then(() => {
          dispatch('privateOffers/table/fetch', null, { root: true });
          dispatch('showPrivateOfferModal', false);
        })
        .catch((errors) => {
          dispatch('setErrors', errors);

          if (errorNotify) {
            errorNotify();
          }
        });
    } else {
      rootGetters['privateOffers/getRepository'].create(state.formData)
        .then(() => {
          dispatch('privateOffers/table/fetch', null, { root: true });
          dispatch('showPrivateOfferModal', false);
        })
        .catch((errors) => {
          dispatch('setErrors', errors);

          if (errorNotify) {
            errorNotify();
          }
        });
    }
  },
  setServices({ commit }, val) {
    commit('SET_SERVICES', val);
  },
  setErrors({ commit }, errors) {
    commit('SET_ERRORS', errors);
  },
  resetState({ commit }) {
    commit('SET_CLEAR_STATE');
  },
  setCountdownEnabled({ commit }, val) {
    commit('SET_COUNTDOWN_ENABLED', val);
  },
  setManager({ commit }, value) {
    commit('SET_MANAGER', value);
  },
  setTopBannerId({ commit }, id) {
    commit('SET_TOP_BANNER_ID', id ?? null);
  },
  setBottomBanner({ commit }, value) {
    commit('SET_BOTTOM_BANNER', value);
  },
  setTopBanner({ commit }, value) {
    commit('SET_TOP_BANNER', value);
  },
  setBottomBannerId({ commit }, id) {
    commit('SET_BOTTOM_BANNER_ID', id ?? null);
  },
  setCreatedAt({ commit }, val) {
    commit('SET_CREATED_AT', val);
  },
  setSlug({ commit }, val) {
    commit('SET_SLUG', val);
  },
  setShown({ commit }, val) {
    commit('SET_SHOWN', val);
  },
  setOfferId({ commit }, id) {
    commit('SET_OFFER_ID', id);
  },
};
